import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { httpService } from '../service/servicio';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { AppComponent } from '../app.component'
import * as jsPDF from 'jspdf';

@Component({
  selector: 'app-lotes',
  templateUrl: './lotes.component.html',
  styleUrls: ['./lotes.component.css']
})
export class LotesComponent implements OnInit {
  editando: boolean = false;
  articulos: any;
  articuloSearch: string = '';
  sort: string;
  desc: string = 'desc'
  muestraStock: boolean = false;
  stocks: any;
  muestraTrazabilidad: boolean = false;
  trazas: any;
  

  constructor(public http:httpService,  public app:AppComponent, public toastr: ToastsManager, vcr: ViewContainerRef, private elem: ElementRef) {

    this.toastr.setRootViewContainerRef(app.vcr);

    this.descargarLotes();

 }

ngOnInit() {
}


@Input() marcas:any;
@Input() modelos:any;
@Input() posiciones:any;
@Input() clientes:any;
@Input() docs:any;


  xServicio:any = [

    { Id:0, Valor:'NO' },
    { Id:1, Valor:'SI' }

  ]


tituloLote:string = 'Nuevo Lote '
loteSearch: string = '';
cargado: boolean = false;
lotes: any = [];
place: string = 'Numero Lote'

clienteactual:any;
posicionactual:any;
mostrarDoc:boolean = false;
mostrarUpload:boolean =false;
nomfich:string = '';
ficheroBorrar:string ='';
loteActual: any;
loaded:boolean = false;
cloaded:number = 0; 
muestraDatos: boolean = false;

pulsado(lote) {
  this.loteActual = lote
  console.log(this.loteActual)
  
  this.editando = true;
  this.tituloLote = 'Editando Lote';
  this.http.descargarArticulos().subscribe( articulos => {
    this.articulos = articulos;
    console.log(this.articulos);
    this.muestraDatos = true;
  })
}

quitarfiltro(tipo?: any) {
  this.loteSearch = '';
}

orden(n) {
  let place =  this.place;
  if (n == 1) { this.sort='id'; this.place='Buscar por Id' };
  if (n == 2) { this.sort='Articulo'; this.place='Buscar por Articulo' };
  if (n == 3) { this.sort='Numero'; this.place='Buscar por Numero' };
  if (n == 4) { this.sort='caducidad'}
  console.log(this.sort, this.place)
  this.loteSearch = '';
  if (this.place == place) {
    if (this.desc == '')
      this.desc = 'desc'
    else  
      this.desc = ''
  }
  
 }

 hoy() {

  let today = new Date();
  let dd = today.getDate().toString();
  let mm = (today.getMonth() + 1).toString();
  let yyyy:string;


  if(today.getDate() < 10) {

    dd = '0'+ dd;
  }

  if (today.getMonth() < 10) {
    mm = '0'+ mm;
  }

  yyyy = today.getFullYear().toString();

  let fecha = yyyy + '-' + mm + '-' + dd;

  return  fecha;

}

crearLote() {
  this.editando = false;
  this.tituloLote = 'Nuevo Lote'
  this.articuloSearch = '';
  this.loteActual = {
    Numero: '',
    fecha: this.hoy(),
    caducidad: this.hoy(),
    idArticulo: 1,
    Stock: 0,
    albaran: '',
    proveedor: ''
  }
  this.http.descargarArticulos().subscribe( articulos => {
    this.articulos = articulos;
    console.log(this.articulos);
    this.muestraDatos = true;
  })


}

volver() {
  this.muestraDatos = false;
}

volverDocs() {

  this.mostrarUpload = false;
  this.mostrarDoc =false;

}



  uploadFile() {

    let files = this.elem.nativeElement.querySelector('#selectFile').files;
    let formData = new FormData();
    let file = files[0];



    formData.append('selectFile', file, file.name);
    formData.append('path', this.http.maquinaGrabar.Id);


    this.http.uploadFile(formData).subscribe( uploaded => {

      this.http.uploaded = uploaded;
      if (this.http.uploaded.Status == 1) {
        this.toastr.success(this.http.uploaded.Text,'Subida de Ficheros');

        this.documentos(this.http.maquinaGrabar.Id);

      }else{
        this.toastr.error(this.http.uploaded.Text,'Subida de Ficheros');
      }

    });


  }

  borrarfichero() {

    this.http.deleteFile(this.http.maquinaGrabar.Id, this.ficheroBorrar).subscribe(respuesta => {

    this.http.uploaded = respuesta;


    }, err => {

     (err.message);
    }, () => {

      if (this.http.uploaded.Status == 1) {
         this.toastr.success(this.http.uploaded.Text,'Base de Datos');
         this.documentos(this.http.maquinaGrabar.Id);

       }else{
         this.toastr.error(this.http.uploaded.Text,'Base de Datos');
      }
    });

  }



  selFichero(fichero) {

    this.ficheroBorrar = fichero;

  }

  documentos(Id) {

    this.nomfich = 'https://www.grupovalenzuela.com/Duran/php/Documentos/' + this.http.maquinaGrabar.Id + '/';

    this.http.descargarDocs(Id).subscribe(doc => {

    this.docs = doc;

    }, err => {

  }, () => {

        this.mostrarUpload = false;
        this.mostrarDoc =true;

    });


  }

  filtro() {

    if (this.docs) {

      return this.docs.filter((doc) => {

         return (doc != '.' && doc!='..');
       });
    }else{

      return this.docs;
    }

  }

  listar() {

    // Only pt supported (not mm or in)

    let doc = new jsPDF('l', 'pt');

    doc.setFont("courier");
    doc.setFontSize(14);
    doc.setFontType("bold");

    doc.text(15,20,"Listado de Lotes ( " + this.filtroLotes().length + " )")
    doc.text(720, 20, this.http.hoy())
    doc.line(15,25,800,25);

    let lineas:any = [];
    let y: number = 40;

    doc.setFontSize(10);
    doc.setFontType("normal");
  /*
    doc.text(0,5, '12345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890');
    doc.text(0,15,'         1         2         3         4         5         6         7         8         9         10       11        12        13        14');
    for (let i=0; i < 800; i+=10) {

      doc.text(i, 25,".");
      doc.text(5,i,".");
    }
    let ii:number = 0;
    let c:number = 0;

    for (let i=0; i < 800; i+=10) {
      ii ++;
      if (ii == 10) {
        c++;
        doc.text(i, 25, c.toString());
        doc.text(10, i, c.toString());

        ii = 0 };

    }
  */
    doc.setFontSize(10);
    doc.setFontType("bold");

    doc.text(15, y, 'Numero');
    doc.text(120, y, 'Entrada');
    doc.text(210, y, 'Caducidad');
    doc.text(300, y, 'Articulo');
    doc.text(500, y, 'Stock');
    doc.text(580, y, 'Albaran');
    doc.text(700, y, 'Proveedor');

    doc.line(15, y + 5, 800, y + 5)

   y = 60;
   doc.setFontType("normal");
   let sw:boolean =true;

   let tabla:any = this.filtroLotes();

    tabla.forEach(lote => {
      if (sw) {
       doc.setTextColor(128,128,128)
     }else {
       doc.setTextColor(0,0,0)
     }

     doc.text(15, y, lote.Numero.slice(0,14));
     doc.text(120, y, lote.fecha.slice(0,12));
     doc.text(210, y, lote.caducidad.slice(0,45));
     doc.text(300, y, lote.Articulo.slice(0,32));
     doc.text(500, y, lote.stock.slice(0,35));
     doc.text(580, y, lote.albaran.slice(0,18));
     doc.text(700, y, lote.proveedor.slice(0,20));

     sw = !sw;

     y+=20;
     if (y > 550)  { doc.addPage(); y = 35 }

    })


        doc.save('lotes.pdf');


  };


borrar(){

    this.http.datosPost.action = 4; // borrar maquina
    this.http.datosPost.datos = this.loteActual;
    this.http.lotes(this.http.datosPost).subscribe(respuesta => {
          this.http.uploaded = respuesta;
          if (this.http.uploaded.Status == 1) {
            this.toastr.success(this.http.uploaded.Text,'Lotes');
            this.http.descargarLotes(0).subscribe(respuesta => {
            this.http.loading = false;
            this.lotes = respuesta
            this.muestraDatos = false;
            });
        }else{
            this.toastr.error(this.http.uploaded.Text,'Lotes');
        }

      }, err => {

      }, () => {
         
    });

}

grabar() {
  
      let id = (<HTMLInputElement>document.getElementById('combo')).value;
      let articulo  = this.articulos.find(art => art.Id ===  id )
      console.log(articulo)
      this.loteActual.idArticulo = articulo.Id
      this.loteActual.Articulo = articulo.nombre
      this.http.datosPost.action = 2;
      if (this.editando)
        this.http.datosPost.action = 3;
      this.loteActual.nombre = 'sn'
      this.http.datosPost.datos = this.loteActual;
      console.log('lote a grabar: ', this.http.datosPost)

      this.http.lotes(this.http.datosPost).subscribe(respuesta => {
            this.http.uploaded = respuesta;
            console.log(respuesta)
            if (this.http.uploaded.Status == 1) {
              this.toastr.success(this.http.uploaded.Text,'Lotes');
              this.http.descargarLotes(0).subscribe(respuesta => {
                this.http.loading = false;
                this.lotes = respuesta
                if (this.editando) this.muestraDatos = false;
                this.articuloSearch = '';
                this.loteActual.Numero = '';
                this.loteActual.stock = '';
                this.loteActual.caducidad = this.hoy();
                
              });
          }else{
              this.toastr.error(this.http.uploaded.Text,'Lotes');
          }
        }, err => {

        }, () => {
          
      });

}

verStocks() {
  this.http.datosPost.action = 5
  this.http.lotes(this.http.datosPost).subscribe( stocks => {
    this.stocks = stocks
    console.log(this.stocks)
    this.muestraStock = true;
    this.loteSearch = '';

  });
}

verLotesZero() {
  this.http.datosPost.action = 1
  this.http.lotes(this.http.datosPost).subscribe( lotes => {
    this.lotes = lotes
    this.muestraStock = false;
    this.loteSearch = '';

  });
}



verLotes() {
  this.http.datosPost.action = 1
  this.http.lotes(this.http.datosPost).subscribe( lotes => {
    this.lotes = lotes
    this.muestraStock = false;
    this.loteSearch = '';

  });
}

volverTrazabilidad() {
  this.muestraDatos = true;
  this.muestraTrazabilidad = false;
  this.cargado = true;
}

trazabilidad() {
  this.http.loading = true;
  this.http.datosPost.action = 7;
  this.http.datosPost.datos = {
   lote: this.loteActual.id
  }
  this.http.lotes(this.http.datosPost).subscribe( traza => {
    console.log('Trazabilidad: ', traza)
    this.http.loading = false;
    this.trazas = traza;
    this.muestraDatos = false;
    this.muestraTrazabilidad = true;
    this.cargado = false;
  })
}


filtroLotes() {
  return this.lotes.filter((lote) => {  
      if (this.sort == 'Numero')
        return (lote.Numero.toLowerCase().indexOf(this.loteSearch.toLowerCase()) !== -1);
      else if (this.sort == 'Articulo')
        return (lote.Articulo.toLowerCase().indexOf(this.loteSearch.toLowerCase()) !== -1);
      else 
        return true;
  });
}

filtroStocks() {
  return this.stocks.filter((stock) => {  
        return (stock.Articulo.toLowerCase().indexOf(this.loteSearch.toLowerCase()) !== -1);
  });
}

filtroArticulos() {
  return this.articulos.filter((art) => {  
        return (art.nombre.toLowerCase().indexOf(this.articuloSearch.toLowerCase()) !== -1);
  });
}



descargarLotes() {
  this.loaded = false;
  this.http.descargarLotes(0)
  .subscribe(lotes => {
      console.log('Lotes: ', lotes)
      this.lotes = lotes;
      this.cargado = true;
      this.http.loading = false;
  }, err => {
     (err.message);
  }, () => {
   
        this.http.sw.mostrarMaquinas = false;
        this.http.sw.mostrarMenu = true;
        this.http.sw.mostrarLotes = true;

  });
}

descargarPosiciones() {
            this.loaded = false;
            this.http.descargarPosiciones()
            .subscribe(posicion => {
                 this.posiciones = posicion;
                 this.posicionactual = this.posiciones.find(posicion => posicion.Id === this.http.maquinaGrabar.posicion);

            }, err => {
               (err.message);
            }, () => {
              if ( (this.http.maquinaGrabar.Id == 0) || (this.posicionactual == null) ) {
                //this.http.maquinaGrabar.cliente = this.clientes[0].Id;
                this.http.maquinaGrabar.marca = this.marcas[0].Id;
                this.http.maquinaGrabar.modelo = this.modelos[0].Id;
                this.selCliente(this.clientes[0].Id);

              }

                  this.posicionactual = this.posiciones.find(posicion => posicion.Id === this.http.maquinaGrabar.posicion);

                  this.clienteactual =  this.clientes.find(cliente => cliente.Id ===  this.posicionactual.cliente);
                  this.loaded=true;


                  this.loaded = true;
                  this.http.sw.mostrarMaquinas = false;
                  this.http.sw.mostrarMenu = false;
                  this.http.sw.mostrarTarifas = false;

            });
  }


  descargarClientes() {

              this.http.descargarClientes()
              .subscribe(cliente => {
                   this.clientes = cliente;

              }, err => {

              }, () => {

                this.descargarPosiciones();
              });
    }

  descargarMarcas() {

              this.http.descargarMarcas()
              .subscribe(marca => {
                   this.marcas = marca;

              }, err => {

              }, () => {

                this.descargarModelos()
              });
    }

  descargarModelos() {

                this.http.descargarModelos()
                .subscribe(modelo => {
                     this.modelos = modelo;

                }, err => {

                }, () => {

                  this.descargarClientes();
                });
      }

  selMarca(Id) {
      this.http.maquinaGrabar.marca = Id;

    }

  selValor(Id) {
        this.http.maquinaGrabar.porservicio = Id;

      }

  selModelo(Id) {
      this.http.maquinaGrabar.modelo = Id;

    }

  selPosicion(Id) {
      this.http.maquinaGrabar.posicion = Id;

  }

  selCliente(Id) {
      this.clienteactual =  this.clientes.find(cliente => cliente.Id ===  Id);
      this.posicionactual = this.posiciones.find(posicion => posicion.cliente === Id);

      this.filtroLotes();
      this.http.maquinaGrabar.posicion = this.posicionactual.Id;

  }

  tarifas() {

     this.http.tarifaGrabar = this.http.nuevaTarifa();
     
     this.http.sw.mostrarDatosmaquinas = false;
     this.http.sw.mostrarTarifas = true;


  }




}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/lotes/lotes.component.ts